import {
  Content,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
} from './Content';
import { ContentNavigation, ContentSection } from './ContentNavigation';
import { Root } from './Root';
import {
  FiltersProvider,
  FiltersProviderWithLabels,
  ResourceGuard,
  Wrapper,
} from './Wrapper';

export const Page = {
  Root,
  ResourceGuard,
  Content,
  ContentNavigation,
  ContentSection,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
  Wrapper,
  FiltersProvider,
  FiltersProviderWithLabels,
};
